import _ from 'lodash'

import { config } from '../config/config-shim'

import { makeRandomString } from '../common'

export const util = {
  devicePixelRatio,
  escapeHtml,
  generateSSOSecret,
  verifySSOSecret,
  paramsFromObject,
}

const SSO_CHARS =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
const ROTATE_SSO = 5 * 60 * 1000
const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;',
  '`': '&#x60;',
  '=': '&#x3D;',
}

const ssoSecrets = {}

function escapeHtml(string) {
  return String(string).replace(/[&<>"'`=/]/g, function (s) {
    return HTML_ESCAPES[s]
  })
}

function devicePixelRatio(): number {
  return window.devicePixelRatio || 1
}

function generateSSOSecret() {
  const secret = makeRandomString(SSO_CHARS, 12)
  ssoSecrets[secret] = Date.now()
  try {
    if (config.platform === 'android') {
      localStorage.setItem('sso-secrets', JSON.stringify(ssoSecrets))
    }
  } catch (err) {
    // todo: do something?
  }
  return secret
}

function verifySSOSecret(secretToVerify) {
  let secrets = ssoSecrets
  if (config.platform === 'android' && _.isEmpty(secrets)) {
    secrets = localStorage.getItem('sso-secrets')
  }
  let rval = false
  _.forEach(secrets, function (ts, secret) {
    if (secret === secretToVerify) {
      rval = true
      delete secrets[secret]
    } else if (ts < Date.now() - ROTATE_SSO) {
      delete secrets[secret]
    }
  })
  try {
    localStorage.setItem('sso-secrets', JSON.stringify(secrets))
  } catch (err) {
    // todo: do something?
  }
  return rval
}

function paramsFromObject(object) {
  const rval = _.reduce(
    object,
    function (arr, entry, key) {
      if (entry) {
        arr.push(`${key}=${encodeURIComponent(entry)}`)
      }
      return arr
    },
    []
  )
  return rval.join('&')
}
// HELPER FUNCTIONS

// function imagePath() {
//   return config.resourceLocation + 'images/'
// }
// function imageExt() {
//   return config.pngMode ? '@2x.png' : '.svg'
// }
